import {Injectable} from '@angular/core';
import {HttpInterceptor, HttpEvent, HttpResponse, HttpRequest, HttpHandler} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthenticationService, NotificationService} from '@Shared/services';

@Injectable()
export class AccountStatusInterceptor implements HttpInterceptor {

    constructor(private router: Router,
                private authenticationService: AuthenticationService,
                private notificationService: NotificationService) {
    }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(httpRequest).pipe(tap((resp) => {
            if (resp instanceof HttpResponse) {
                if (!resp.body.status && resp.body.messages && resp.body.messages.includes('TOKEN_INVALID')) {
                    this.authenticationService.loginManager(null, false);
                    this.authenticationService.alive = false;
                    window.location.reload();
                    return;
                }
                if (!resp.body.status && resp.body.messages && resp.body.messages.includes('ACCOUNT_DEACTIVATED')) {
                    if (this.authenticationService.getCurrentUser()) {
                        this.authenticationService.logout().subscribe(() => {
                            this.authenticationService.loginManager(null, false);
                            this.authenticationService.alive = false;
                            this.router.navigate(['/']);
                        }, error => {
                            console.log(error);
                            this.notificationService.error(error);
                        });
                    }
                }
            }
        }, error => {
            console.log(error);
            this.notificationService.error(error);
        }));
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/interceptors/account-status-interceptor.ts